module.exports = __webpack_public_path__ + "img/erweima.3b983dfb.jpg";